import * as React from "react";
import { injectModels } from "../../redux/injectModels";
import { toast } from "react-toastify";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Routes } from "../../constants";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import JoditEditor from "jodit-react";
import { ViewSop } from "./ViewSop";

const EditSop = (props) => {
  const { session_id } = useParams();
  const navigate = useNavigate();
  const [value, setValue] = useState(""); // To store SOP text
  const [isRecognitionActive, setIsRecognitionActive] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [Start, setStart] = useState("");
  const recognitionRef = useRef(null); // SpeechRecognition instance reference
  const rangeRef = useRef(null); // Range reference for cursor position
  const [show, setShow] = useState(false);
  // const [recall, setRecall] = useState(false);
  const editor = useRef(null); // Reference to Jodit editor
  const editableDivRef = useRef(null);
  let recognition;
  let lastRange; // To store the last cursor position

useEffect(() => {
  handleViewSop();
  window.SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!window.SpeechRecognition) {
    alert(
      "Your browser does not support Speech Recognition. Please try Chrome."
    );
  } else {
    recognition = new window.SpeechRecognition();
    setStart(recognition);
    recognition.lang = "en-US"; // Set the language
    recognition.interimResults = false; // We only want final results, not partial ones
    recognition.continuous = isRecognitionActive; // Enable continuous listening mode

    // Save the current cursor position when the user clicks within the contenteditable div
    document
      .getElementById("editableDiv")
      .addEventListener("mouseup", function () {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
          lastRange = selection.getRangeAt(0); // Store the range (cursor position)
        }
      });
    // When speech recognition detects results
    recognition.addEventListener("result", function (event) {
      const transcript = event.results[event.resultIndex][0].transcript;
    

      // Insert the transcribed text at the last cursor position
      insertTextAtCursor(transcript);
    });
  }
  recognition.addEventListener('end', function() {
    console.log('Speech recognition service disconnected');
    setIsActive(true);
    // if (recognition.continuous) {
    //   recognition.start();  // Restart automatically unless manually stopped
    // }
  });
}, []);

  function insertTextAtCursor(text) {
    const editableDiv = document.getElementById("editableDiv");

    // Get the last saved range (cursor position)
    if (lastRange) {
      const selection = window.getSelection();
      selection.removeAllRanges(); // Clear any existing ranges
      selection.addRange(lastRange); // Restore the last saved range

      // Create a text node for the transcribed text
      const textNode = document.createTextNode(text);

      // Insert the text node at the cursor position
      lastRange.insertNode(textNode);

      // Move the cursor after the inserted text
      lastRange.setStartAfter(textNode);
      lastRange.setEndAfter(textNode);
      selection.removeAllRanges();
      selection.addRange(lastRange);

      // Update the range (cursor position) to the new location after insertion
      lastRange = selection.getRangeAt(0);
    }
    // setValue(editableDiv.innerHTML)
  }

  const handleViewSop = async () => {
    try {
      props.application.setLoading(true);
      const res = await props.admin.viewSop(session_id);
      if (res.success) {
        setValue(res.data);
      } else {
        toast.error(res.message, { position: toast.POSITION.TOP_CENTER });
      }
      props.application.setLoading(false);
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
    }
  };

  const handleEditSop = async () => {
    try {
      props.application.setLoading(true);
      const data = { sop_value: value, sop_id: session_id };
      const res = await props.admin.editSop(data);
      if (res.success) {
        toast.success("Sop successfully updated!", {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate(Routes.SESSION);
      } else {
        toast.error(res.message, { position: toast.POSITION.TOP_CENTER });
      }
      props.application.setLoading(false);
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
      });
      props.application.setLoading(false);
    }
  };

 
  // Start speech recognition
const startSpeechRecognition = () => {
  if (Start) {
    Start.start();
    // setIsRecognitionActive(true);
    setIsActive(false); // Indicate that recognition is active
  }
};

// Stop speech recognition
const stopSpeechRecognition = () => {
  if (Start) {
    Start.stop();
    setIsRecognitionActive(false); // Manually set recognition inactive
    setIsActive(true); // Indicate that recognition is stopped
  }
};

  // const handleClose = () => {
  //   // setRecall(true);
  //   setShow(false);
  //   setIsRecognitionActive(true); 
  //   }
  const handleShow = () => {
   
    stopSpeechRecognition();
    
    setTimeout(()=>{setShow(true);
      setValue(editableDivRef.current.innerHTML);
    },1000)
    // setShow(true);
   
  };

  return (
    <div>
      <main id="main" className="main">
        <div className="pagetitle mb-3">
          <h1>View Sop</h1>
          <nav>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <NavLink to={Routes.DASHBOARD}>Home</NavLink>
              </li>
              <li className="breadcrumb-item active">View Sop</li>
            </ol>
          </nav>
        </div>
        {show === true ? (
       
          <ViewSop value={value} handleEditSop={handleEditSop} setValue={setValue} />
        ) : (
          <section className="section dashboard">
            <div className="row">
              <div className="col-12">
                <div className="card recent-sales overflow-auto">
                  <div className="card-body p-3">
                    <div className="data-se">
                      <div className="d-flex justify-content-end">
                        <div className="mic-reco"> 
                          {/* <button
                          className="btn btn-primary"
                          onClick={handleEditSop}
                        >
                          Update Sop{"  "}
                          <span>
                            <i className="bi bi-pencil-fill"></i>
                          </span>
                        </button>*/}

                          {isActive ? (
                            <button className="start-mic" onClick={startSpeechRecognition}>
                              <i className="fa-solid fa-microphone"></i>
                            </button>
                          ) : (
                            <button className="stop-mic" onClick={stopSpeechRecognition}>
                              <i className="fa-solid fa-microphone-slash"></i>
                            </button>
                          )}
                        </div>
                      </div>
                      <div
                        id="editableDiv"
                        ref={editableDivRef}
                        contenteditable="true"
                        dangerouslySetInnerHTML={{ __html: value }}
                      ></div>

                      <button
                        className="btn btn-secondary ml-2"
                        onClick={handleShow}
                      >
                        Edit Sop
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </main>
    </div>
  );
};
export default injectModels(["admin", "application"])(EditSop);

